import { Component } from "@angular/core";

/**
 * Onglet ndf
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'ndf'},
    templateUrl: './ndf.component.html'
})
export class NdfComponent {}
